// Function to calculate the total discount
function calculateTotalDiscount() {
  var totalDiscount = 0;
  var items = Shopify.cart.items;

  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    var originalPrice = 0;
    var finalPrice = item.final_price;
    var quantity = item.quantity;
    var itemDiscount = (originalPrice - finalPrice) * quantity;
    totalDiscount += itemDiscount;
  }

  return totalDiscount;
}

// Function to update the total discount element
function updateTotalDiscountElement(totalDiscount) {
  document.getElementById('total-discount').innerText = Shopify.formatMoney(totalDiscount);
}

// Function to handle cart updates and re-calculate total discount
function handleCartUpdate() {
  var totalDiscount = calculateTotalDiscount();
  console.log('Total Discount:', totalDiscount); // Debugging line
  updateTotalDiscountElement(totalDiscount);
}


// Attach event listeners for cart updates
document.addEventListener('cart.requestComplete', handleCartUpdate);
document.addEventListener('cart.requestFailed', handleCartUpdate);

// Trigger the initial calculation when the page loads
document.addEventListener('DOMContentLoaded', function () {
  var initialTotalDiscount = calculateTotalDiscount();
  updateTotalDiscountElement(initialTotalDiscount);
});
